import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'fe-leasing',
    templateUrl: './leasing.component.html',
    styleUrls: ['./leasing.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class LeasingComponent implements OnInit {
    isEnglish = false;
    constructor(private router: Router) {}
    ngOnInit(): void {
        this.isEnglish = this.router.url.startsWith('/en/');
    }
}
